import { __assign } from "tslib";
import { createCartExports } from './cart/exports.cart';
import { createCheckoutExports } from './checkout/exports.checkout';
import { createWishlistExports } from './wishlist/exports.wishlist';
import { createBackInStockExports } from './backInStock/exports.backInStock';
import { createSettingsExports } from './settings/exports.settings';
import { createPaymentsExports } from './payments/exports.payments';
import { createProductExports } from './product/exports.product';
import { createNavigateExports } from './navigate/exports.navigate';
export var createPartialOnlineStoresPublicApi = function (_a) {
    var context = _a.context, origin = _a.origin, isOnlineStoresViewerScript = _a.isOnlineStoresViewerScript;
    return ({
        product: createProductExports({ context: context, origin: origin, isOnlineStoresViewerScript: isOnlineStoresViewerScript }),
        navigate: createNavigateExports({ context: context, origin: origin }),
        backInStock: createBackInStockExports({ context: context, origin: origin, isOnlineStoresViewerScript: isOnlineStoresViewerScript }),
        settings: createSettingsExports({ context: context, origin: origin }),
        payments: createPaymentsExports({ context: context }),
        wishlist: createWishlistExports({ context: context }),
    });
};
export var createExports = function (_a) {
    var context = _a.context, origin = _a.origin;
    return (__assign({ cart: createCartExports({ context: context }), checkout: createCheckoutExports({ context: context }) }, createPartialOnlineStoresPublicApi({ context: context, origin: origin, isOnlineStoresViewerScript: true })));
};
//# sourceMappingURL=createExports.js.map